export const faqGroups = [
  {
    id: "general",
    label: "General Services",
    icon: "🛠️",
    items: [
      { q: "What services does Auto Basic Care offer?", a: "We provide preventive maintenance, oil changes, brakes, tire services, diagnostics, suspension repair, electrical repair, tune-ups, battery replacement, cooling system services, inspections, and general automotive repair services." },
      { q: "Do you work on all vehicle brands?", a: "Yes. Auto Basic Care services most domestic, foreign, and commercial vehicle brands." },
      { q: "Do I need an appointment?", a: "Appointments are recommended, but walk-ins are welcome depending on availability." },
      { q: "Do you offer towing assistance?", a: "Yes. We can help coordinate towing services for non-drivable vehicles." },
      { q: "Do you offer fleet maintenance services?", a: "Yes. We provide fleet maintenance programs and discounted partnership pricing for businesses and commercial vehicles." },
    ],
  },
  {
    id: "oil",
    label: "Oil Changes",
    icon: "🛢️",
    items: [
      { q: "How often should I get an oil change?", a: "Most vehicles should receive oil changes every 3,000–7,500 miles depending on manufacturer recommendations and oil type." },
      { q: "What type of oil do you use?", a: "We offer conventional, synthetic blend, and full synthetic oil options based on your vehicle requirements." },
      { q: "How long does an oil change take?", a: "Most oil changes take approximately 30–60 minutes depending on vehicle type and additional inspections." },
      { q: "Do you check fluids during an oil change?", a: "Yes. We inspect and top off applicable fluids during routine maintenance services." },
    ],
  },
  {
    id: "tires",
    label: "Tires & Alignment",
    icon: "🛞",
    items: [
      { q: "Do you sell tires?", a: "Yes. We offer multiple tire brands and options including all-season, performance, touring, and climate tires." },
      { q: "Do your tires include warranties?", a: "Select tire purchases include manufacturer-backed warranties ranging from 40,000–70,000 miles depending on tire brand and model." },
      { q: "What voids a tire warranty?", a: "Improper alignment, suspension problems, uneven wear, lack of tire rotations, road hazards, impacts, and misuse may void warranty coverage." },
      { q: "How often should tires be rotated?", a: "Tires should typically be rotated every 5,000–7,000 miles." },
      { q: "Do you provide wheel alignments?", a: "Yes. We provide alignment inspections and alignment services to help maximize tire life." },
    ],
  },
  {
    id: "brakes",
    label: "Brake Services",
    icon: "🛑",
    items: [
      { q: "How do I know if my brakes need service?", a: "Common signs include squeaking, grinding, vibration, soft brake pedals, or increased stopping distance." },
      { q: "Do you replace rotors and brake pads?", a: "Yes. We replace brake pads, rotors, calipers, and brake components as needed." },
      { q: "How long do brake services take?", a: "Brake services typically take 1–3 hours depending on the repair needed." },
    ],
  },
  {
    id: "battery",
    label: "Battery Services",
    icon: "🔋",
    items: [
      { q: "Do your batteries include warranties?", a: "Yes. Eligible batteries may include limited warranties ranging from 2–4 years depending on the manufacturer." },
      { q: "What is included with battery installation?", a: "Battery installation may include charging system testing and terminal inspection." },
      { q: "Why would a battery warranty be denied?", a: "Corrosion, abuse, electrical system issues, improper installation, and physical damage may void battery warranty coverage." },
    ],
  },
  {
    id: "diagnostics",
    label: "Diagnostics & Electrical",
    icon: "⚡",
    items: [
      { q: "Do you perform electrical diagnostics?", a: "Yes. We diagnose electrical issues including batteries, starters, alternators, wiring, charging systems, sensors, and modules." },
      { q: "Do you charge diagnostic fees?", a: "Yes. Diagnostic fees may apply depending on the issue and testing required." },
      { q: "Can you diagnose check engine lights?", a: "Yes. We provide check engine light diagnostics and repair recommendations." },
    ],
  },
  {
    id: "suspension",
    label: "Suspension & Steering",
    icon: "🔧",
    items: [
      { q: "What are signs of suspension problems?", a: "Uneven tire wear, pulling, bouncing, vibrations, loose steering, and clunking noises are common signs." },
      { q: "Do you replace shocks and struts?", a: "Yes. We service shocks, struts, control arms, ball joints, sway bars, and steering components." },
      { q: "Why is alignment important?", a: "Proper alignment improves tire life, fuel economy, ride quality, and steering performance." },
    ],
  },
  {
    id: "warranty",
    label: "Warranty Coverage",
    icon: "🛡️",
    items: [
      { q: "What warranty does Auto Basic Care provide?", a: "Eligible repairs include a 12,000-mile workmanship warranty unless otherwise specified." },
      { q: "What is covered under warranty?", a: "Coverage may include labor-related defects, installation-related issues, and manufacturer defects on eligible replacement parts." },
      { q: "Are labor charges covered under warranty claims?", a: "Warranty replacement parts or tires may be covered, but labor charges, balancing, mounting, taxes, and shop fees may still apply." },
      { q: "What is required for warranty approval?", a: "Proof of purchase, inspections, maintenance history, and technician evaluation may be required." },
      { q: "Does warranty coverage transfer to another owner?", a: "Warranty coverage generally applies only to the original purchaser and serviced vehicle." },
    ],
  },
  {
    id: "fleet",
    label: "Fleet & Commercial",
    icon: "🚚",
    items: [
      { q: "Do you work with business fleets?", a: "Yes. We offer customized maintenance plans for fleets and commercial vehicles." },
      { q: "Do you offer discounted partnership pricing?", a: "Yes. Partnership discounts may be available based on service volume and business needs." },
      { q: "Can businesses set up billing accounts?", a: "Yes. Commercial billing options may be available upon approval." },
    ],
  },
  {
    id: "preventive",
    label: "Preventive Maintenance",
    icon: "⭐",
    items: [
      { q: "Why is preventive maintenance important?", a: "Preventive maintenance helps reduce breakdowns, improve vehicle reliability, increase safety, and lower long-term repair costs." },
      { q: "What maintenance should be done regularly?", a: "Oil changes, tire rotations, brake inspections, fluid services, battery inspections, alignments, and cooling system maintenance are commonly recommended." },
      { q: "Can preventive maintenance improve fuel economy?", a: "Yes. Proper maintenance can improve fuel efficiency and overall vehicle performance." },
    ],
  },
];
